import {Title, Sex, Gender} from '@cypro/engine/database/schema'

export const sexList = Object.values(Sex.enum)
export const genderList = Object.values(Gender.enum)
export const titleList = Object.values(Title.enum)

export const URINARY_COLLECTION_TIME = 1440
